import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CompanyStorageService {
  private COMPANY_DATA = 'company_data';

  setCompany(data: { companyId: string; verifyToken: string }) {
    localStorage.setItem(
      this.COMPANY_DATA,
      JSON.stringify({
        ...data,
        verified: true,
      }),
    );
  }

  getCompany() {
    const raw = localStorage.getItem(this.COMPANY_DATA);
    return raw ? JSON.parse(raw) : null;
  }

  getVerifyToken(): string | null {
    return this.getCompany()?.verifyToken || null;
  }

  isVerified(): boolean {
    return !!this.getCompany()?.verified;
  }

  clear() {
    localStorage.removeItem(this.COMPANY_DATA);
  }
}

